import { IRequiredCertificationGroup } from 'models/certifications';

export interface Certification {
  id: string;
  name: string;
  certificationId?: string;
  certificationTypeId?: string; // The ID of the certification type (from API: certificateId)
  description?: string;
  issueDate: string;
  expirationDate: string;
  lastUpdatedAt?: string;
  projectsRequired: string[];
  status?: CertificationStatus;
  logoUrl?: string;
  isNewCertificateAvailable?: boolean;
}

export interface RequiredCertificate {
  id: string;
  projectId: string;
  projectName: string;
  certificationGroups: IRequiredCertificationGroup[];
  status: CertificationStatus.REQUIRED;
}

export enum CertificationStatus {
  REQUIRED = 'REQUIRED',
  EXPIRED = 'EXPIRED',
  CURRENT = 'CURRENT',
}

export enum TabIndex {
  REQUIRED = 0,
  EXPIRED = 1,
  CURRENT = 2,
}

export enum SortType {
  NAME_ASC = 'name asc',
  NAME_DESC = 'name desc',
  DATE_ASC = 'lastUpdatedAt asc',
  DATE_DESC = 'lastUpdatedAt desc',
}

export interface CertificationCounts {
  all: number;
  required: number;
  expired: number;
  current: number;
}

export interface FilterState {
  search: string;
  selectedOptions: string[];
  noRelatedProject?: boolean; // For FilterCertificateRelatedTo = 2
}
